import Text from 'components/Text/Text';
import React, { useContext, useRef, useEffect } from 'react';
import { Form } from 'antd';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import {
	ChangeModifierPositionContext,
	IChangeModifierPositionContext,
} from '../../../changeModifierPositionState/changeModifierPositionContext';
import style from './BtnBlock.module.scss';

const BtnBlock: React.FC = () => {
	const { changeTypeOfModalWindow, setDataForSubmit, positionsData, IDSelectedModifierGroup, typeOfModalWindow } =
		useContext<IChangeModifierPositionContext>(ChangeModifierPositionContext);

	const originalPositionsOrder = useRef(positionsData ? [...positionsData] : null);

	const compareOrders = () => {
		if (originalPositionsOrder.current && positionsData) {
			const updatedPositionsOrder = positionsData;

			for (let i = 0; i < originalPositionsOrder.current.length; i++) {
				if (originalPositionsOrder.current[i].id !== updatedPositionsOrder[i].id) {
					return false;
				}
			}
			return true;
		}
	};

	const isTheSameOrder = compareOrders();

	const handleCancel = () => {
		changeTypeOfModalWindow('toConfirmFieldsClearing');
	};

	const handleConfirm = async () => {
		const modifierIds = positionsData.map((el) => el.id);

		if (positionsData && IDSelectedModifierGroup) {
			setDataForSubmit({
				modifierGroupId: IDSelectedModifierGroup,
				modifierIds,
			});
			changeTypeOfModalWindow('toConfirmSubmit');
		}
	};

	useEffect(() => {
		if (typeOfModalWindow === 'success') {
			originalPositionsOrder.current = [...positionsData];
		}
	}, [typeOfModalWindow]);

	return (
		<Form.Item>
			<div className={style.container} data-test="BtnBlock">
				<Button
					className={style.cancelBtn}
					theme="outlined"
					onClick={handleCancel}
					icon={
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#resetIcon`} />
						</svg>
					}>
					<Text translationNameSpace="listing" translationKey="cancelButton" asFragment={true} />
				</Button>
				<Button
					className={style.saveBtn}
					theme="primaryBlue"
					onClick={handleConfirm}
					type="submit"
					disabled={isTheSameOrder}>
					<Text translationNameSpace="listing" translationKey="saveButton" asFragment={true} />
				</Button>
			</div>
		</Form.Item>
	);
};

export default BtnBlock;
